import React, {FC, useContext, useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {Modal} from "react-bootstrap";
import {RootState} from "../../../../../reducers";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import ItemHelper from "../../../../services/Menu/services/Item/ItemHelper";
import IframeWidget from "../../../../utils/IframeWidget";
import {getItemGroups, getItems, getMenus} from "../../../../services/Menu/reducer";
import MenuShowItemSingleComponent from "../../components/Item/MenuShowItemSingleComponent";
import Analytics from "../../../../services/Common/Analytics/Analytics";
import AppConfig from "../../../../services/AppConfig";
import {usePrefix} from "../../../../services/Prefix";
import {getCart} from "../../../../services/Cart/reducer";
import {getVouchers} from "../../../../services/User/reducer";
import {useTranslation} from "react-i18next";
import {VoucherProductsContext} from "../../../../services/VoucherProducts/VoucherProductsContext";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

const MenuAddItemPage: FC<Props> = (props) => {
    const [modal, setModal] = useState(true);
    const {items, menus} = props;
    const {menuId: paramMenuId, id: paramId} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const prefix = usePrefix();
    const {t} = useTranslation();
    const {handleOnPromotionLimit, handleRemovePromotion} = useContext(VoucherProductsContext)

    useEffect(() => {
        let item = ItemHelper.getItem(items, id);
        if (item) {
            if (location.state && location.state.back) {
                Analytics.selectItem(item);
            }
            Analytics.viewItem(item);
        }
    }, []);

    if (!paramId || !paramMenuId) return null;

    const id = parseInt(paramId);
    const menuId = parseInt(paramMenuId);


    const addItem = async (addedItem: any, addedMenuId: any) => {
        await hideModal(addedItem, addedMenuId);
    }

    const hideModal = async (addedItem: any, addedMenuId: any) => {
        IframeWidget.closeModal();
        setModal(false);

        const isItemInCart = addedItem?.item_id === item.id;

        if (location.state?.promotionId && !isItemInCart) {
            await handleRemovePromotion();
        }

        if (location.state?.fromVoucher) {
            handleOnPromotionLimit(addedItem);
        }

        if (location.state && location.state?.back) {
            if (IframeWidget.isInit()) {
                navigate('/');
            } else {
                navigate(-1);
            }
        } else {
            navigate(AppConfig.getLinkWithPrefix(`/menu/${menuId}`, prefix), {replace: true, state: {action: 'stay'}});
        }
    };

    const menusById = menus.filter((menu: any) => menu.id === menuId);
    let menu = undefined;

    if (menusById.length > 0) {
        menu = menusById[0];
    }

    let item = ItemHelper.getItem(items, id);

    if (item === undefined) return null;

    let productImgView = null;

    if (item.image_link) {
        productImgView = (
            <div className="product-item-img">
                <img src={item.image_link.default} alt={t("common.word.product_image")}/>
            </div>
        )
    }

    const itemGroup = ItemHelper.getItemGroup(props.itemGroups, item.id);

    const handleOnHideMenuShowItemModal = async (addedItem: any, addedMenuId: any) => {
        if (location.state?.fromVoucher) {
            IframeWidget.closeModal();
            setModal(false);

            if (location.state && location.state?.back) {
                if (IframeWidget.isInit()) {
                    navigate('/');
                } else {
                    navigate(-1);
                }
            } else {
                navigate(AppConfig.getLinkWithPrefix(`/menu/${menuId}`, prefix), {
                    replace: true,
                    state: {action: 'stay'}
                });
            }
        } else {
            await hideModal(addedItem, addedMenuId);
        }
    }

    return (
        <Modal dialogClassName={"modal-full modal-product modal-product-full"} show={modal}
               aria-labelledby="menu_item_base_modal_title"
               onHide={() => IframeWidget.onHide(handleOnHideMenuShowItemModal)} onShow={() => IframeWidget.onShow()}>
            <div className={"modal-product-content"}>
                {productImgView}
                <div className={"modal-product-full-right"}>
                    <div className={"container-fluid"}>
                        <MenuShowItemSingleComponent itemId={item.id} itemGroup={itemGroup} onUpdate={addItem}
                                                     menu={menu}
                                                     onHide={() => IframeWidget.onHide(handleOnHideMenuShowItemModal)}/>
                    </div>
                </div>
            </div>
        </Modal>
    )
}


const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    menus: getMenus(state.menu),
    cart: getCart(state.cart),
    vouchers: getVouchers(state.user),
})

const connector = connect(mapStateToProps);

export default connector(MenuAddItemPage);